export default __webpack_public_path__ + "static/media/13.1a5feb67.jpg";